import {AfterViewInit, Component, ElementRef, HostListener, ViewChild, ViewEncapsulation} from '@angular/core';
import {BaseSectionComponent} from "../base-section/base-section.component";
import {PageFreeSection} from "../../../models/Page/Sections/PageFreeSection";
import {PageItineraryFiche, PageItinerarySection} from "../../../models/Page/Sections/PageItinerarySection";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";
import {SynapiMapComponent} from "../../elements/synapi-map/synapi-map.component";
import {SynapiListItems} from "../../../models/Synapi/SynapiListItems";
import {SynapiPredicate} from "../../../models/Synapi/SynapiPredicate";
import {SynapiService} from "../../../services/synapi.service";
import {CommonModule, NgForOf} from "@angular/common";
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'itineraire-section',
  standalone: true,
  imports: [
    BaseSectionComponent,
    SafeHtmlPipe,
    SynapiMapComponent,
    CommonModule,
    MediaAttachmentComponent,
    AttachmentFromIdPipe,
    SynapiListItemsComponent,
    RouterLink,

  ],
  templateUrl: './itineraire-section.component.html',
  styleUrl: './itineraire-section.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ItineraireSectionComponent extends BaseSectionComponent<PageItinerarySection> implements AfterViewInit{
  @ViewChild("map") mapRef?: SynapiMapComponent;
  @ViewChild("list") listRef?: SynapiListItemsComponent;
  @ViewChild("itineraireContainer") itineraireContainerRef?: ElementRef;
  @ViewChild("itineraireContent") itineraireContentRef?: ElementRef;
  @ViewChild("itineraireMapContainer") itineraireMapContainerRef?: ElementRef;
  public mapItems : SynapiListItems = new SynapiListItems();
  public waypointItems : SynapiItem[] = [];
  public mapPredicate: SynapiPredicate = new SynapiPredicate();
  public listPredicate: SynapiPredicate = new SynapiPredicate();
  public waypoints: number[][] = [];
  public distance: string = "";
  public duration: string = "";
  constructor(public synapi: SynapiService) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initItems();
  }

  initItems(){
    const itemsPredicate = new SynapiPredicate();
    itemsPredicate.ids = this.sectionRendered.fiches.map(fiche => fiche.fiche.id);
    this.synapi.getItems(itemsPredicate).then((items)=>{
      if(items.items){
        this.waypointItems = items.items;
        this.sectionRendered.fiches.forEach((ficheGroup) => {
          this.initStepFicheData(ficheGroup.fiche);
          if(ficheGroup.fiche && ficheGroup.fiche.id){
            const item = items.items.find(item => item.ExternalId == ficheGroup.fiche.id);
            if(item){
              ficheGroup.fiche.item = item;
              if(ficheGroup.fiche.latitude && ficheGroup.fiche.longitude){
                const lat = parseFloat(ficheGroup.fiche.latitude);
                const lng = parseFloat(ficheGroup.fiche.longitude);
                ficheGroup.fiche.item.Localisation.Lat = lat;
                ficheGroup.fiche.item.Localisation.Lon = lng;
                this.waypoints.push([lat, lng]);
              } else {
                this.waypoints.push([item.Localisation.Lat, item.Localisation.Lon]);
              }
            }
          }
        });
      }
      this.mapPredicate.id = this.sectionRendered.selection_sit;
      this.itemsForMap();
    });
  }

  ngAfterViewInit() {


  }
  async itemsForMap(){
    const items = this.waypointItems;
    const mapItems = await this.synapi.getSmallItems(this.mapPredicate);
    mapItems?.items.forEach(mapItem => {
      if(!items.find(item => mapItem.ExternalId == item.ExternalId)){
        items.push(mapItem);
      }
    });
    this.mapItems.items = items;
  }

  onPlaceTabClick(fiche: PageItineraryFiche, tab: string) {
    fiche.isTabInformations = false;
    fiche.isTabAround = false;
    fiche.isTabOnTheRoad = false;
    // @ts-ignore
    fiche[tab] = true;
  }

  initStepFicheData(fiche:PageItineraryFiche){
    if(fiche.informations){
      fiche.isTabInformations = true;
    } else if(fiche.around){
      fiche.isTabAround = true;
    } else if(fiche.on_the_road){
      fiche.isTabOnTheRoad = true;
    }
  }

  onDistanceChange($event: number) {
    //convert number meters to km
    this.distance = Math.round($event / 1000)+ "Km";
  }

  onDurationChange(event: number) {
    const seconds = event;
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      this.duration = `${days} jour${days > 1 ? 's' : ''}`;
    } else if (hours > 0) {
      this.duration = `${hours} heure${hours > 1 ? 's' : ''}`;
    } else if (minutes > 0) {
      this.duration = `${minutes} minute${minutes > 1 ? 's' : ''}`;
    } else {
      this.duration = `${seconds} seconde${seconds > 1 ? 's' : ''}`;
    }
  }

  @HostListener('document:scroll', []) onWindowScroll() {
    if(this.itineraireMapContainerRef && this.itineraireContainerRef){
      const client = this.itineraireContainerRef.nativeElement.getClientRects();
      const headerNavbarHeight = document.getElementById("HeaderNavbar")?.clientHeight || 0;
      const pageNavHeight = document.getElementById("PageNavigation")?.clientHeight || 0;
      if(client[0].top < 0){
        this.itineraireMapContainerRef.nativeElement.style.top = Math.abs(client[0].top)+headerNavbarHeight+pageNavHeight+"px";
      } else {
        this.itineraireMapContainerRef.nativeElement.style.top = 0;
      }
      this.itineraireMapContainerRef.nativeElement.style.height = window.outerHeight - (headerNavbarHeight+pageNavHeight) + "px";
    }
  }

  onPredicateChange($event: SynapiPredicate) {
    this.listPredicate.ids = $event.elements;
    this.listPredicate.textsearch = "";
    this.listPredicate.page = 1;
    this.itemsForList();
  }

  async itemsForList(isExternalChange= true){
    if(this.listRef){
      this.listRef.loading = true;
      this.listRef.reset();
      this.listRef.updateListItems(await this.synapi.getItems(this.listPredicate));
    }
  }
}
